import i18n from "./i18nextInitiator";
const t = i18n.getFixedT('fa','invoiceTrack');

const getStatusText = (status) => {
    switch (status) {
        case 1:
            return t("tracker.invoice-tracker.0");
        case 2:
            return t("tracker.invoice-tracker.1");
        case 4:
            return t("tracker.invoice-tracker.2");
        case 5:
            return t("tracker.invoice-tracker.3");
        case 6:
            return t("tracker.invoice-tracker.4");
        case 7:
            return t("canceled");
        default:
            return t("tracker.invoice-tracker.0");
    }
}
export default getStatusText;